export const menu = {
    namespaced: true,
    state: {
        menuState: false
    },
    getters: {
        menuIsOpened: state => state.menuState
    },
    mutations: {
        TOGGLE_MENU_STATE(state) {
            state.menuState = !state.menuState;
        },
        SET_MENU_STATE(state, menuState) {
            state.menuState = menuState;
        }
    },
    actions: {
        toggleMenuState(context) {
            context.commit("TOGGLE_MENU_STATE");
        },
        setMenuState(context, menuState) {
            context.commit("SET_MENU_STATE", menuState);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/basket/menu.js